import { render, staticRenderFns } from "./plan-parameters-add.vue?vue&type=template&id=0a0cb975&scoped=true"
import script from "./plan-parameters-add.vue?vue&type=script&lang=js"
export * from "./plan-parameters-add.vue?vue&type=script&lang=js"
import style0 from "./plan-parameters-add.vue?vue&type=style&index=0&id=0a0cb975&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0cb975",
  null
  
)

export default component.exports